import { useTranslations } from 'next-intl'
import { useCallback, useMemo } from 'react'

import { COMPANY_SWITCHER_MODAL_KEY } from '@maestro/commerce-blocks/components/company-switcher/company-switcher.constants'
import { useMaestroSession } from '@maestro/commerce-blocks/providers/maestro-session/maestro-session.context'
import { useEventBusContext } from '@maestro/core/event/event-bus.context'
import { EventType } from '@maestro/data-layer'
import { useHash } from '@pearlconvert/ui/hooks/use-hash'

export const useTopbarCompanySwitcher = () => {
  const { addOrUpdateHashParam } = useHash()
  const t = useTranslations('commerce-blocks.company-switcher')
  const { session } = useMaestroSession()
  const { publish } = useEventBusContext()

  const handleClickCompanySwitcher = useCallback(() => {
    publish(EventType.SLIDE_IN_OPENED, {
      title: t('title'),
      slideInType: COMPANY_SWITCHER_MODAL_KEY,
      action: 'open',
    })
    addOrUpdateHashParam(COMPANY_SWITCHER_MODAL_KEY)
  }, [addOrUpdateHashParam, publish, t])

  const isUserLoggedIn = useMemo(() => {
    return !!session?.user?.id
  }, [session?.user?.id])

  return {
    handleClickCompanySwitcher,
    isUserLoggedIn,
  }
}
